import { IoMdArrowRoundDown } from "react-icons/io";
import SeasonCarousel from "./SeasonCarousel";

const Seasons = () => {
  return (
    <div className="flex flex-col gap-5 items-center justify-center w-full container">
      <div className="h-full w-full max-w-6xl">
        <SeasonCarousel />
      </div>

      <button className="bg-none md:bg-white/45 w-[239px] h-[70px] text-[20px] md:text-3xl font-kalameh rounded-[35px] text-white flex items-center justify-center gap-4">
        ادامه بده
        <IoMdArrowRoundDown className="text-white w-4 md:w-6 h-4 md:h-6" />
      </button>
    </div>
  );
};

export default Seasons;
